<template>
  <el-dialog
    v-model="visible"
    :custom-class="cls"
    :show-close="false"
    :before-close="beforeClose"
    :top="top"
  >
    <template #header>
      <div class="flex items-center justify-between text-gray-500">
        <span class="text-xl">{{ title }}</span>
        <XIcon class="w-6 h-6 cursor-pointer" v-if="isClose" @click="$emit('close', true)" />
      </div>
    </template>
    <slot></slot>
  </el-dialog>
</template>

<script lang="ts">
import { XIcon } from '@heroicons/vue/outline'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogView',
  components: {
    XIcon,
  },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String },
    size: { type: String, default: 'normal' },
    isClose: { type: Boolean, default: true },
    top: { type: String, default: '15vh' },
  },
  setup(_, ctx) {
    const visible = computed(() => _.open)
    const shouldShowActions = computed(() => !!ctx.slots.actions)
    const cls = _.size === 'big' ? 'lg:max-w-6xl xl:max-w-7xl' : 'w-full lg:max-w-xl xl:max-w-2xl'

    const beforeClose = () => false
    return { visible, shouldShowActions, cls, beforeClose }
  },
})
</script>
